"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class BigLink extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "panel panel-primary" },
            React.createElement("div", { className: "panel-heading", style: { cursor: "pointer" }, onClick: this.props.onClick },
                React.createElement("span", null,
                    React.createElement("i", { className: this.props.icon }),
                    this.props.label)),
            React.createElement("div", { className: "panel-body", style: { color: "#0066CC", fontStyle: "italic" } }, this.props.description)));
    }
}
exports.BigLink = BigLink;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/bigLink.js
// module id = 2200
// module chunks = 0